<template>
  <el-dialog
      v-el-drag-dialog
      title="批量删除"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="user-edit"
      width="1000px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        class="form"
        label-width="100px">
      <el-transfer
          v-model="finalDataList"
          filterable
          :data="initDataList"
          :props="{key: 'id', label: 'name'}"
          :titles="['未选择文件', '已选择文件']"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "PanBatchDelete",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        finalDataList: [],
        initDataList: [],
      };
    },
    methods: {
      open(data) {
        this.dialogVisible = true;
        this.initDataList = data;
        console.log(data);
      },
      handleSubmit() {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","pans/idList",this.finalDataList).then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("select");
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };

</script>
<style lang="scss">
.el-transfer-panel{
  width: 360px!important;
}
</style>
